import React from "react";

const StatusBadge = ({ active }) => (
  <span
    className={`px-2 py-1 rounded text-xs font-semibold ${
      active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
    }`}
  >
    {active ? "Active" : "Inactive"}
  </span>
);

export default StatusBadge;
